var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$route.params.tasktype === "newUser")?_c('newUser',{attrs:{"userID":_vm.$route.params.id,"taskID":_vm.$route.params.taskId}}):_vm._e(),(_vm.$route.params.tasktype === "newFileUpload")?_c('newFileUpload'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }